import { TeamSelectorProviderStateType } from '../../components/forms/teamselector/types';
import { USER_SYNC_FILTER_TEAMS_OPTIONS } from '../../scene/integrations/types';

export const teamSelectorProviderStateMock: TeamSelectorProviderStateType = {
  teamOptions: [],
  isIntegrationTeamsError: false,
  isIntegrationTeamsLoading: false,
  isIntegrationDataFilled: false,
  isPermittedForIntegrationTeams: false,
  teamSelectorMode: USER_SYNC_FILTER_TEAMS_OPTIONS.includeSelected,
  selectedTeams: [],
};
